import React from 'react';
import { Button } from 'antd';

interface DrupiPrimaryActionButtonProps {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
}

export const DrupiPrimaryActionButton: React.FC<DrupiPrimaryActionButtonProps> = ({
  label,
  icon,
  onClick,
  disabled = false,
  loading = false,
  fullWidth = false
}) => {
  return (
    <Button
      icon={icon}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      type="primary"
      style={{
        borderRadius: 8,
        width: fullWidth ? '100%' : 'auto',
      }}
    >
      {label}
    </Button>
  );
};
